<template>
  <Modal v-model="model"  sticky reset-drag-position title="分配技能组座席" @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="shuttle_frame"  width="700">
    <div class="shuttle_left">
      <div class="font_style_set"><Checkbox v-model="leftAll" @on-change="handleLeft"></Checkbox>源列表</div>
      <Input suffix="ios-search" v-model="handleLeftValue" placeholder="搜索查询" @on-change="handleLeftSearch"/>
      <CheckboxGroup v-model="shuttleLeftList">
        <Checkbox v-for="(item,index) in leftData" :key="index" :label="item.id">{{item.agentNum}}</Checkbox>
      </CheckboxGroup>
    </div>
    <div class="shuttle_middle">
      <Button type="info" class="right" :disabled="shuttleLeftList.length==0" @click="moveToRight">右移</Button>
      <Button type="info" class="left"  :disabled="shuttleRightList.length==0" @click="moveToLeft">左移</Button>
    </div>
    <div class="shuttle_right">
      <div class="font_style_set"><Checkbox v-model="rightAll" @on-change="handleRight"></Checkbox>目标列表</div>
      <Input suffix="ios-search" v-model="handleRightValue" placeholder="搜索查询" @on-change="handleRightSearch"/>
      <CheckboxGroup v-model="shuttleRightList">
        <Checkbox v-for="(item,index) in rightData" :key="index" :label="item.agentId">
          <span>{{item.agentNum}}</span>
          <el-select v-model="item.level" :id="'handleLevel'+index" style="width: 100px" @change="changeLevel">
            <el-option v-for="option in levelList" :key="option.value" :label="option.name" :value="option.level"></el-option>
          </el-select>
        </Checkbox>
      </CheckboxGroup>
      <div class="btn_template" style="margin-top:15px">
        <Button type="error" class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="save()">保存</Button>
      </div>
    </div>
    
  </Modal>
</template>

<script>
    export default {
      name: "SkillDistributionPop",
      props:{
        showDistribution:Boolean,
        skillId:String
      },
      data(){
        return{
          model:false,
          shuttleLeftList:[],
          shuttleRightList:[],
          initLeftData:[],
          leftData:[],
          initTargetData:[],
          rightData: [],
          leftAll:false,
          rightAll:false,
          handleLeftValue:'',
          handleRightValue:'',
          levelList:[{'level':'0','name':'等级0'},{'level':'1','name':'等级1'},{'level':'2','name':'等级2'},{'level':'3','name':'等级3'},{'level':'4','name':'等级4'},
                    {'level':'5','name':'等级5'},{'level':'6','name':'等级6'},{'level':'7','name':'等级7'},{'level':'8','name':'等级8'},{'level':'9','name':'等级9'}]
          }
      },
      methods:{
        changeLevel:function(){
          // this.moveCount++;
        },
        //左边查询
        handleLeftSearch:function(){
          this.leftData=[];
          if(!this.handleLeftValue){
            this.leftData=this.initLeftData;
            return false;
          }
          for (let i=0;i<this.initLeftData.length;i++){
            let agentNum=this.initLeftData[i].agentNum;
            if(agentNum && agentNum.indexOf(this.handleLeftValue)!=-1){
              this.leftData.push(this.initLeftData[i]);
            }
          }
        },
        //右边查询
        handleRightSearch:function(){
          this.rightData=[];
          if(!this.handleRightValue){
            this.rightData=this.initTargetData;
            return false;
          }
          for (let i=0;i<this.initTargetData.length;i++){
            let agentNum=this.initTargetData[i].agentNum;
            if(agentNum && agentNum.indexOf(this.handleRightValue)!=-1){
              this.rightData.push(this.initTargetData[i]);
            }
          }
        },
        //左边全选
        handleLeft:function(){
          this.shuttleLeftList=[];
          if(this.leftAll){
            for (let i=0;i<this.leftData.length;i++){
              this.shuttleLeftList.push(this.leftData[i].id);
            }
          }
        },
        //右边全选
        handleRight:function(){
          this.shuttleRightList=[];
          if(this.rightAll){
            for (let i=0;i<this.rightData.length;i++){
              this.shuttleRightList.push(this.rightData[i].agentId);
            }
          }
        },
        moveToLeft:function(){
          let list=this.shuttleRightList;
          this.rightAll=false;
          this.shuttleRightList=[];
          for (let i=0;i<list.length;i++){
            let id=list[i];
            for (let k=0;k<this.rightData.length;k++){
             if(id==this.rightData[k].agentId){
                let param={
                  id:id,
                  agentNum:this.rightData[k].agentNum
                };
                this.leftData.unshift(param);
                let count=0;
                for (let a=0;a<this.initLeftData.length;a++){
                 if(id==this.initLeftData[a].id){
                   count++;
                 }
               }
               if(count==0){
                 this.initLeftData.unshift(param);
               }
             }
            }
          }
          let newList=[];
          for (let b=0;b<this.rightData.length;b++){
            if(list.toString().indexOf(this.rightData[b].agentId)=="-1"){
              newList.push(this.rightData[b]);
            }
          }
          let initNewList=[];
          for (let m=0;m<this.initTargetData.length;m++){
            if(list.toString().indexOf(this.initTargetData[m].agentId)=="-1"){
              initNewList.push(this.initTargetData[m]);
            }
          }
          this.rightData=newList;
          this.initTargetData=initNewList;
          // this.moveCount++;
        },
        moveToRight:function(){
          let list=this.shuttleLeftList;
          this.leftAll=false;
          this.shuttleLeftList=[];
          for (let i=0;i<list.length;i++){
            let id=list[i];
            for (let k=0;k<this.leftData.length;k++){
              if(id==this.leftData[k].id){
                let param={
                  agentId:id,
                  level:'0',
                  agentNum:this.leftData[k].agentNum
                };
                this.rightData.unshift(param);
                let count=0;
                for (let a=0;a<this.initTargetData.length;a++){
                  if(id==this.initTargetData[a].agentId){
                    count++;
                  }
                }
                if(count==0){
                  this.initTargetData.unshift(param);
                }
              }
            }
          }
          let newList=[];
          for (let b=0;b<this.leftData.length;b++){
            if(list.toString().indexOf(this.leftData[b].id)=="-1"){
              newList.push(this.leftData[b]);
            }
          }
          let initNewList=[];
          for (let m=0;m<this.initLeftData.length;m++){
            if(list.toString().indexOf(this.initLeftData[m].id)=="-1"){
              initNewList.push(this.initLeftData[m]);
            }
          }
          this.leftData=newList;
          this.initLeftData=initNewList;
          // this.moveCount++;
        },
        save: function(){
          let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定保存当前修改",
            onOk: () => {
              let agentRight=[];
              for (let m=0;m<that.rightData.length;m++){
                agentRight.push(that.rightData[m].agentId+"-"+that.rightData[m].level);
              }
              let param={
                id:that.skillId,
                agentRight:agentRight.toString(),
                journalType:"CTI配置=>技能组=>分配",
                menuId:"1_2-4"
              };
              that.$http.post("skillGroup/doAssignation.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("技能组分配成功");
                that.cancel();
              });
            }
          });
        },
        cancel:function () {
         
            this.$emit("closeDistribution",false);
            return false;
        },
        init:function () {
          let that=this;
          let param={
            id:this.skillId,
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("skillGroup/toAssignation.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            that.leftData=res.data.obj.agentList;
            that.initLeftData=res.data.obj.agentList;
            that.rightData=res.data.obj.list;
            that.initTargetData=res.data.obj.list;
          });
        }
      },
      watch:{
        showDistribution:function () {
          this.model=this.showDistribution;
          if(this.showDistribution){
            this.shuttleLeftList=[];
            this.shuttleRightList=[];
            this.init();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/SkillDistributionPop.vue